module.exports = __webpack_public_path__ + "static/media/excel_image.4d0a13c2.svg";